import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from '../endpoints';

export const api = {
  getRole: (id: number) => {
    return new RemoteAdminData(endpoint.role.data)
      .resource<ApiResponse<any>>()
      .withId(String(id))
      .single();
  },
  addRole: async (role) => {
    const response = await new RemoteAdminData(endpoint.role.add)
      .resource<any>()
      .create(role, false);
    return await response.json();
  },
  updateRole: async (id: number, role: any) => {
    return new RemoteAdminData(endpoint.role.edit)
      .resource<ApiResponse<any>>()
      .withId(id)
      .save(role);
  }
};
